import { cx } from '@libs/classnames';
import {
  FancyModal,
  FancyModalPanel,
  FancyModalPanelProps,
  FancyPanelAction,
  FancyPanelTitle,
} from '@ui/components/panels/FancyPanel';
import { CameraIcon } from '@ui/icons/CameraIcon';

import { Props as StreamPanelProps, StreamPanel } from './StreamPanel';

import styles from './CamerasSetupModal.module.css';

export type Props = Omit<StreamPanelProps, 'className'> & {
  onClose: () => void;
};

// Настройка видеоконтроля в модалке: одна камера или две рядом
export function CamerasSetupModal({ cameras, notice, onClose }: Props) {
  return (
    <FancyModal {...panelProps(cameras, onClose)}>
      <Title />
      <StreamPanel cameras={cameras} notice={notice} />
    </FancyModal>
  );
}

// Сама панель без оверлея: для сторибука
export function CamerasSetupPanel({ cameras, notice, onClose }: Props) {
  return (
    <FancyModalPanel {...panelProps(cameras, onClose)}>
      <Title />
      <StreamPanel cameras={cameras} notice={notice} />
    </FancyModalPanel>
  );
}

/*
    ____,-------------------------------,____
    \   |            Helpers            |   /
    /___|-------------------------------|___\
*/

function panelProps(
  cameras: StreamPanelProps['cameras'],
  onClose: () => void,
): FancyModalPanelProps {
  return {
    className: cx(styles.panel, { [styles.is_double]: cameras.length > 1 }),
    contentClassName: styles.content,
    actions: (
      <FancyPanelAction
        className={cx({ [styles.is_accent]: cameras.every(isSettled) })}
        onClick={onClose}
      >
        Закрыть
      </FancyPanelAction>
    ),
    onClose,
  };
}

// Камера пристроена: вошла в комнату с этого устройства (ждет судью или в эфире) или показывает
// QR-код для другого устройства. Когда пристроены все, «Закрыть» становится акцентной:
// подсказка, что диалог можно закрыть
function isSettled(camera: StreamPanelProps['cameras'][number]): boolean {
  if (camera.mode === 'other') return true;
  return camera.mode === 'device' && (camera.status === 'live' || camera.status === 'waiting');
}

// Заголовок с мелким подзаголовком, как на плашке турнира; при прокрутке остается наверху
function Title() {
  return (
    <header className={styles.header}>
      <FancyPanelTitle className={styles.title}>
        <CameraIcon className={styles.title__icon} />
        Видеоконтроль
      </FancyPanelTitle>
      <p className={styles.subtitle}>Для участия в турнире нужна видеотрансляция</p>
    </header>
  );
}
